import React from 'react'
import '../App.css'
import Bodynegativebalancereport from './bodynegativebalancereport'
export class Bodyappnegativebalancereportbody extends React.Component {
    state = {
    }
    render() {       
        return (
            <div className="flex flex-row space-x-4"> {/* flex-row organiza los elementos horizontalmente */}
                <Bodynegativebalancereport/>
            </div>    
        );
    }
}